import { VerifyUserDto } from '@fantaz/shared/data-access/api';
import { createAction, createActionGroup, props } from '@ngrx/store';

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// ~~~~~~~~~~~~~~~~~~~~~~~~ EditInfo Actions For Dialog ~~~~~~~~~~~~~~~~~~~~~~~~
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
export const openEditInfoDialog = createAction('[EditInfo/UI] Open Dialog');
export const closeEditInfoDialog = createAction('[EditInfo/UI] Close Dialog');

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// ~~~~~~~~~~~~~~~~~~~~~~~~ EditInfo Actions For Dialog ~~~~~~~~~~~~~~~~~~~~~~~~
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
export const SaveEditInfoActions = createActionGroup({
  source: '[EditInfo/API]',
  events: {
    // update user profile
    'Save User Profile': props<{ user: VerifyUserDto }>(),
    'Save User Profile Success': props<{ user: VerifyUserDto }>(),
    'Save User Profile Failure': props<{ error: any; user?: VerifyUserDto }>(),
    'User Profile After Save': props<{ user: VerifyUserDto }>(),

    // kyc
    'Kyc User': props<{ user: VerifyUserDto }>(),
    'Kyc User Success': props<{ user: VerifyUserDto }>(),
    'Kyc User Failure': props<{ error: any; user?: VerifyUserDto }>(),
  },
});
export const saveEditInfo = createAction(
  '[EditInfo/API] Save Info',
  props<{
    user: VerifyUserDto;
  }>(),
);

export const saveEditInfoSuccess = createAction(
  '[EditInfo/API] Save Info Success',
);

export const saveEditInfoFailure = createAction(
  '[EditInfo/API] Save Info Failure',
  props<{ error: any }>(),
);
